import { gql } from 'apollo-boost';

const articleDetailQuery = slug => gql`
  {
    entry(uri: "decode/article/${slug}", site: "decode") {
      title
      postDate
      ... on decodeArticleDetailPage_decodeArticleDetail_Entry {
        category {
          title
        }
        decodeSecondaryCategory {
          title
        }
        decodeArticleCards {
          ... on decodeArticleCards_c1_BlockType {
            backgroundColor
            contentEyebrow
            contentHeadline
            coverImage {
              url
              title
              mimeType
            }
            imageFit
          }
          ... on decodeArticleCards_c2_BlockType {
            backgroundColor
            contentEyebrow
            contentHeadline
            coverImage {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c3_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
            caption
          }
          ... on decodeArticleCards_c4_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
            header
            paragraphC4: paragraph
          }
          ... on decodeArticleCards_c5_BlockType {
            backgroundColor
            sectionTitle
            caption
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c6_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
            caption
            paragraphC6: paragraph
          }
          ... on decodeArticleCards_c7_BlockType {
            backgroundColor
            caption
            paragraphC7: paragraph
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c8_BlockType {
            backgroundColor
            sectionTitle
            paragraphC8: paragraph
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c9_BlockType {
            backgroundColor
            firstLetterOfTheParagraph
            articleAsset1 {
              url
              mimeType
              title
            }
            articleAsset2 {
              url
              mimeType
              title
            }
            imageFit
            paragraphC9: paragraph
          }
          ... on decodeArticleCards_c10_BlockType {
            backgroundColor
            firstLetter
            articleAsset1 {
              url
              mimeType
              title
            }
            articleAsset2 {
              url
              mimeType
              title
            }
            imageFit
            paragraphC10: paragraph
          }
          ... on decodeArticleCards_c11_BlockType {
            backgroundColor
            articleAsset1 {
              url
              mimeType
              title
            }
            articleAsset2 {
              url
              mimeType
              title
            }
            imageFit
            paragraphC11: paragraph
          }
          ... on decodeArticleCards_c12_BlockType {
            customDisplayType
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c13_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
            sectionTitle
          }
          ... on decodeArticleCards_c14_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            imageFit
            barColor
            caption
          }
          ... on decodeArticleCards_c15_BlockType {
            backgroundColor
            sectionTitle
            caption
            barColor
            paragraphC15:paragraph
          }
          ... on decodeArticleCards_c16_BlockType {
            backgroundColor
            header
            paragraphC16: paragraph
          }
          ... on decodeArticleCards_c17_BlockType {
            backgroundColor
            paragraphC17: paragraph
            barColor
            caption
          }
          ... on decodeArticleCards_c18_BlockType {
            backgroundColor
            header
            paragraphC18:paragraph
            barColor
            caption
          }
          ... on decodeArticleCards_c19_BlockType {
            backgroundColor
            header
            paragraphC19: paragraph
          }
          ... on decodeArticleCards_c20_BlockType {
            backgroundColor
            header
            paragraphC20: paragraph
          }
          ... on decodeArticleCards_c21_BlockType {
            backgroundColor
            creditInfo {
              ... on creditInfo_BlockType {
                eyebrow
                jobTitle
                personName
              }
            }
            paragraphC21:paragraph
            footerSection {
              ... on footerSection_BlockType {
                footerCopy
                footerLinkCopy
                footerLink
                showArrowIcon
                arrowIconColor
              }
            }
            clapIconColor
            socialIconColor
          }
          ... on decodeArticleCards_c22_BlockType {
            backgroundColor
            articleAsset {
              url
              mimeType
              title
            }
            paragraphC22: paragraph
            dashColor
            personName
            articleAsset2 {
              url
              mimeType
              title
            }
            imageFit
          }
          ... on decodeArticleCards_c23_BlockType {
            backgroundColor
            articleAsset1 {
              url
              mimeType
              title
            }
            imageFit
            dashColor
            personName
            paragraphC23: paragraph
          }
          ... on decodeArticleCards_c24_BlockType {
            customDisplayType
            backgroundColor
            barColor
            paragraphC24:paragraph
            number
            header
          }
          ... on decodeArticleCards_c25_BlockType {
            backgroundColor
            sectionTitle
            caption
            instagramPostId
          }
          ... on decodeArticleCards_c27_BlockType {
            backgroundColor
            sectionTitle
            caption
            twitterPostId
          }
          ... on decodeArticleCards_c28_BlockType {
            backgroundColor
            sectionTitle
            caption
            youtubeVideoId
          }
          __typename
        }
        socialMetaSection {
          ... on socialMetaSection_metaFields_BlockType {
            metaTitle
            metaDescription
            metaImage {
              url
              title
            }
            metaKeywords
          }
        }
      }
    }
  }
`;

export default articleDetailQuery;
